import { CalendarCheckIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { EmptyState } from '../ui/EmptyState';
import { useAdmin } from '../AdminContext';
import { btnPrimary, btnSecondary, listBox } from '../ui/styles';
import { paidFromKuur, settleState } from './kassaLabels';
import type { KassaAppointment } from '../../core/types/kassa';
type Props = {
  items: KassaAppointment[];
  editable: boolean;
  onSettle: (a: KassaAppointment) => void;
};

/** De afspraken van de dag zonder bon, op tijd. Afgerond in de agenda = klaar om af te rekenen. */
export function ToSettleList({
  items,
  editable,
  onSettle
}: Props) {
  const {
    index
  } = useAdmin();
  if (items.length === 0) {
    return <EmptyState icon={CalendarCheckIcon} title="Niets meer af te rekenen" text="Elke afspraak van deze dag heeft een bon, of er stonden geen salonafspraken." data-id="element-2495" data-mp="sy5v24ufu8z0" />;
  }
  return <ul className={listBox} aria-label="Af te rekenen" data-id="element-2496" data-mp="1glnjbqehuox8">
      {items.map(a => {
      const state = settleState(a);
      const kuur = paidFromKuur(a);
      return <li key={a.id} className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3.5 sm:px-5" data-id="element-2497" data-mp="27lytv7pfuseu">
            <span className="w-12 shrink-0 text-[14px] tabular-nums text-muted" data-id="element-2498" data-mp="22nxasms0it3d">{a.time}</span>
            <span className="min-w-0 flex-1" data-id="element-2499" data-mp="2gfbuywxnp0c0">
              <span className="block truncate text-[14px] text-ink" data-id="element-2500" data-mp="2bnapbtuzu7uy">{a.customerName}</span>
              <span className="block truncate text-[12px] text-muted" data-id="element-2501" data-mp="2qbyenie8xlcg">
                {index.treatmentBySlug(a.treatmentSlug)?.name ?? a.treatmentSlug}
                {kuur && ` · kuursessie ${a.session}, al betaald`}
              </span>
            </span>
            <Badge tone={state.tone} data-id="element-2502" data-mp="2zc3dh45djbf0">{state.label}</Badge>
            {editable && <button type="button" onClick={() => onSettle(a)} className={a.finished ? btnPrimary : btnSecondary} data-id="element-2503" data-mp="2vccqzcmvrhga">
                Afrekenen
              </button>}
          </li>;
    })}
    </ul>;
}